import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Routes from "./Routes/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";

// Import Scss
import "./assets/scss/theme.scss";

// Fake Backend
import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
fakeBackend();

// Firebase
// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const AuthWrapper = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  // Don't redirect if we're already on the login page or other public routes
  if (
    location.pathname === '/login' || 
    location.pathname === '/register' || 
    location.pathname === '/EmployeeLogin' ||
    location.pathname === '/forgot-password' ||
    location.pathname === '/employee-forgot-password' ||
    location.pathname === '/verify-otp' ||
    location.pathname === '/reset-password' ||
    location.pathname === '/privacy-policy' ||
    location.pathname === '/terms-conditions' ||
    location.pathname === '/contact-us'
  ) {
    return children;
  }

  if (!token || !user || token === 'undefined' || user === 'undefined') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
};

function App() {
  const location = useLocation();
  const token = localStorage.getItem("token");
  console.log("location", location, token);
  // if (token) {
  //   if (location.pathname === '/login' || location.pathname === '/register') {
  //     window.location.href = '/'
  //   }
  // }

  return (
    <React.Fragment>
      <AuthWrapper>
        <Routes />
      </AuthWrapper>
    </React.Fragment>
  );
}

export default App;
